import { InputAdvisability } from 'views/components/molecules/establishes/inputAdvisability';
import { InputConsent } from 'views/components/molecules/establishes/inputConsent';
import { InputChoices } from 'views/components/molecules/establishes/inputChoices';
import { InputLetter } from 'views/components/molecules/establishes/inputLetter';
import {
  AdvanceQuestionFormikType,
  FinancialIntermediaryStrs,
  FinancialIntermediaryCenterStrs,
  FormErrorScrollTarget,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { AgreementDocumentInfo } from 'views/utils/graphql/graphql';

type AdvanceQuestionTemplateType = {
  formik: AdvanceQuestionFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
  };
  agreementDocuments: AgreementDocumentInfo[];
};

enum AgreementDocumentType {
  terms = 1,
  preContact = 2,
  infoSharing = 3,
  antisocial = 4,
}

export const AdvanceQuestionTemplate = ({ formik, buttonProps, agreementDocuments }: AdvanceQuestionTemplateType) => {
  return (
    <>
      {/* 事前質問 */}
      <div className="establishWrapper">
        {!!formik.errors.financialIntermediaryInvitation && <FormErrorScrollTarget />}
        <InputAdvisability
          title="口座開設の申込の勧誘を金融商品仲介業者（株式会社ＦＰＧ）から受けましたか？"
          name="agency"
          agreeText="はい"
          denialText="いいえ"
          agreeValue="true"
          denialValue="false"
          batchDangerWord="必須"
          checked={formik.values.financialIntermediaryInvitation ?? undefined}
          onChange={(checked) => {
            formik.setFieldValue('financialIntermediaryInvitation', checked);
            formik.setFieldValue('financialIntermediary', checked ? '株式会社FPG' : null);
          }}
          isEnabled={!!formik.errors.financialIntermediaryInvitation}
          errorText={formik.errors.financialIntermediaryInvitation}
        />
      </div>
      {/* 事前質問の答えが「はい」の場合、コンポーネントを表示している */}
      {formik.values.financialIntermediaryInvitation && (
        <>
          <div className="establishWrapper hiddenBg">
            <div className="establishWrapper_announce">
              <h1>勧誘業者情報を入力してください</h1>
              <span>
                私を株式会社FPGに紹介した紹介元（その継承人を含みます）がある場合、紹介元における顧客の紹介状況等管理のため、株式会社FPGを通して紹介元へ取引に関する情報が提供されることに同意します
              </span>
            </div>
          </div>
          <div className="establishWrapper hiddenBg">
            {/* <InputAdvisability
              title="口座開設の申込の勧誘を受けるに際して、「金融商品仲介業に関する明示事項」の説明・交付を受けましたか?"
              name="invitation"
              agreeText="はい"
              denialText="いいえ"
              agreeValue="true"
              denialValue="false"
              batchDangerWord="必須"
              checked={formik.values.financialIntermediaryExplanation ?? undefined}
              onChange={(checked) => formik.setFieldValue('financialIntermediaryExplanation', checked)}
              isEnabled={!!formik.errors.financialIntermediaryExplanation}
              errorText={formik.errors.financialIntermediaryExplanation}
            /> */}
            {!!formik.errors.financialIntermediaryExplanation && <FormErrorScrollTarget />}
            <InputConsent
              title="口座開設の申込の勧誘を受けるに際して、「金融商品仲介業に関する明示事項」の説明・交付を受けましたか?"
              name="invitation"
              batchDangerWord="必須"
              checkText="説明・交付を受けた"
              isChecked={
                formik.values.financialIntermediaryExplanation ? formik.values.financialIntermediaryExplanation : false
              }
              setIsChecked={(e) => formik.setFieldValue('financialIntermediaryExplanation', e.target.checked || null)}
              isEnable={!!formik.errors.financialIntermediaryExplanation}
              errorText={formik.errors.financialIntermediaryExplanation}
            />
          </div>
          <div className="establishWrapper hiddenBg">
            {!!formik.errors.financialIntermediary && <FormErrorScrollTarget />}
            <InputChoices
              title="勧誘業者名"
              batchDangerWord="必須"
              selectedOption={formik.values.financialIntermediary ? formik.values.financialIntermediary : ''}
              setSelectedOption={(selectedOption) => formik.setFieldValue('financialIntermediary', selectedOption)}
              options={FinancialIntermediaryStrs}
              isEnabled={!!formik.errors.financialIntermediary}
              errorText={formik.errors.financialIntermediary}
            />
          </div>

          <div className="establishWrapper hiddenBg">
            {!!formik.errors.financialIntermediaryCenter && <FormErrorScrollTarget />}
            <InputChoices
              title="勧誘業者拠点名"
              batchDangerWord="必須"
              selectedOption={
                formik.values.financialIntermediaryCenter ? formik.values.financialIntermediaryCenter : ''
              }
              setSelectedOption={(selectedOption) =>
                formik.setFieldValue('financialIntermediaryCenter', selectedOption)
              }
              options={FinancialIntermediaryCenterStrs}
              isEnabled={!!formik.errors.financialIntermediaryCenter}
              errorText={formik.errors.financialIntermediaryCenter}
            />
          </div>

          <div className="establishWrapper hiddenBg">
            {!!formik.errors.managerCode && <FormErrorScrollTarget />}
            <InputLetter
              inputType="number"
              title="担当者コード"
              batchDangerWord="必須"
              inputValue={formik.values.managerCode ?? undefined}
              setInputValue={(e) => formik.setFieldValue('managerCode', e.target.value)}
              isEnable={!!formik.errors.managerCode}
              errorText={formik.errors.managerCode}
              placeholder="担当者コードを入力してください"
            />
          </div>
        </>
      )}

      <div className="establishWrapper">
        {!!formik.errors.ageConfirmation && <FormErrorScrollTarget />}
        <InputConsent
          title="年齢確認"
          name="age"
          batchDangerWord="必須"
          checkText="18歳以上です"
          isChecked={formik.values.ageConfirmation ? formik.values.ageConfirmation : false}
          setIsChecked={(e) => formik.setFieldValue('ageConfirmation', e.target.checked)}
          isEnable={!!formik.errors.ageConfirmation}
          errorText={formik.errors.ageConfirmation}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.residenceConfirmation && <FormErrorScrollTarget />}
        <InputConsent
          title="居住国確認"
          batchDangerWord="必須"
          name="country"
          checkText="日本国内に居住しています"
          isChecked={formik.values.residenceConfirmation ? formik.values.residenceConfirmation : false}
          setIsChecked={(e) => formik.setFieldValue('residenceConfirmation', e.target.checked)}
          isEnable={!!formik.errors.residenceConfirmation}
          errorText={formik.errors.residenceConfirmation}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.idConfirmation && <FormErrorScrollTarget />}
        <InputConsent
          title="身分証明書確認"
          name="identification"
          batchDangerWord="必須"
          checkText="「マイナンバーカード」「運転免許証」「運転経歴証明書」「在留カード」または「特別永住者証明書」を保有しています"
          isChecked={formik.values.idConfirmation ? formik.values.idConfirmation : false}
          setIsChecked={(e) => formik.setFieldValue('idConfirmation', e.target.checked)}
          isEnable={!!formik.errors.idConfirmation}
          errorText={formik.errors.idConfirmation}
        />
      </div>

      <div className="establishWrapper">
        {!!formik.errors.pepsConfirmation && <FormErrorScrollTarget />}
        <InputConsent
          title="外国PEPsの確認"
          batchDangerWord="必須"
          name="identification"
          checkText="外国PEPs（外国の政府要人やその親族等）に該当しません"
          isChecked={formik.values.pepsConfirmation ? formik.values.pepsConfirmation : false}
          setIsChecked={(e) => formik.setFieldValue('pepsConfirmation', e.target.checked)}
          isEnable={!!formik.errors.pepsConfirmation}
          errorText={formik.errors.pepsConfirmation}
        />
      </div>

      <div className="establishWrapper">
        {(!!formik.errors.electronicDocumentAgreement || !!formik.errors.isReadElectronicDocumentAgreement) && (
          <FormErrorScrollTarget />
        )}
        <InputConsent
          title="電磁的方法による提供の同意・承諾"
          name="identification"
          batchDangerWord="必須"
          onClickLink={() => {
            formik.setFieldValue('isReadElectronicDocumentAgreement', true);
          }}
          checkText="証券取引約款第５章の規定を確認し、電磁的方法による提供に同意・承諾のうえ、電子交付サービスを申し込みます"
          isChecked={formik.values.electronicDocumentAgreement ? formik.values.electronicDocumentAgreement : false}
          setIsChecked={(e) => formik.setFieldValue('electronicDocumentAgreement', e.target.checked)}
          linkTitle="証券取引約款について"
          linkUrl={agreementDocuments.find((x) => x.Type === AgreementDocumentType.terms)?.URL}
          isEnable={!!formik.errors.electronicDocumentAgreement || !!formik.errors.isReadElectronicDocumentAgreement}
          errorText={formik.errors.isReadElectronicDocumentAgreement || formik.errors.electronicDocumentAgreement}
        />
        <span className="establishWrapper_description">
          ＜電磁的方法の種類及び内容＞
          <br />
          電子交付サービスにおいて、弊社は次のいずれかの電磁的方法を使用いたします
          <br />
          <br />
          ・電子メールを使用する方法
          <br />
          ・弊社のウェブページからダウンロードする方法
          <br />
          ・弊社のウェブページに備えられた顧客ファイルを利用する方法
          <br />
          ・弊社のウェブページで閲覧に供する方法
          <br />
          <br />
          電子交付サービスをご利用するためには、弊社が推奨するバージョン以上のPDF形式のファイル閲覧ソフト及びブラウザソフト等が必要です
        </span>
      </div>
      {buttonProps && (
        <div className="establishWrapper">
          <div className="establishWrapper_buttons">
            <Button {...buttonProps.prevButtonProps} />
            <Button {...buttonProps.nextButtonProps} />
          </div>
        </div>
      )}
    </>
  );
};
